"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("next/router");
const nprogress_1 = __importDefault(require("nprogress"));
const react_1 = require("react");
function useProgressBar() {
    const router = (0, router_1.useRouter)();
    (0, react_1.useEffect)(() => {
        router.events.on('routeChangeStart', nprogress_1.default.start);
        router.events.on('routeChangeComplete', nprogress_1.default.done);
        router.events.on('routeChangeError', nprogress_1.default.done);
        return () => {
            router.events.off('routeChangeStart', nprogress_1.default.start);
            router.events.off('routeChangeComplete', nprogress_1.default.done);
            router.events.off('routeChangeError', nprogress_1.default.done);
        };
    }, [router.events]);
}
exports.default = useProgressBar;
//# sourceMappingURL=useProgressBar.js.map